var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramasDeFormacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.987,
    height: 110.986,
    viewBox: "0 0 110.987 110.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a4c2f7;}.b{fill:#e3e7f2;}.c{fill:#f1eaf4;}.d{fill:#efd2ff;}.e{fill:#fff;}.f{fill:#264ecc;}.g{fill:#7821a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-508.921 -885.302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(510.771 887.151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M607.385,898.1v68.441a3.711,3.711,0,0,1-3.7,3.7H514.9a3.711,3.711,0,0,1-3.7-3.7V898.1a3.731,3.731,0,0,1,3.552-3.7h88.937A3.711,3.711,0,0,1,607.385,898.1Z",
    transform: "translate(-511.197 -888.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M601.836,898.1v68.441a3.711,3.711,0,0,1-3.7,3.7H514.9a3.711,3.711,0,0,1-3.7-3.7V898.1a3.731,3.731,0,0,1,3.552-3.7h83.388A3.71,3.71,0,0,1,601.836,898.1Z",
    transform: "translate(-511.197 -888.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M560.993,893.127V960.18a5.886,5.886,0,0,0-5.734-6.012H520.3V891.277a3.711,3.711,0,0,1,3.7-3.7h31.446a5.541,5.541,0,0,1,5.549,5.55Z",
    transform: "translate(-512.9 -887.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M560.993,975.5v1.388H520.3v-7.4H555.26A5.885,5.885,0,0,1,560.993,975.5Z",
    transform: "translate(-512.9 -902.901)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.092)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M618.29,891.277v62.892h-5.549V891.277a3.711,3.711,0,0,0-3.7-3.7h5.549A3.711,3.711,0,0,1,618.29,891.277Z",
    transform: "translate(-577.593 -887.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M605.5,891.277v62.892H576.092a5.887,5.887,0,0,0-5.734,6.012V893.127a5.543,5.543,0,0,1,5.55-5.55h25.9A3.712,3.712,0,0,1,605.5,891.277Z",
    transform: "translate(-570.356 -887.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.798 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M570.358,975.5v1.388h40.7v-7.4H576.092A5.887,5.887,0,0,0,570.358,975.5Z",
    transform: "translate(-537.062 -902.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M544.2,919.023l-7.4-9.249-7.4,9.249V887.577h14.8Z",
    transform: "translate(-529.401 -887.577)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M619.01,939.912h-11.1a14.795,14.795,0,0,0-14.8,14.8v35.145a14.794,14.794,0,0,0,14.8,14.8h11.1a14.794,14.794,0,0,0,14.8-14.8V954.711a14.795,14.795,0,0,0-14.8-14.8Z",
    transform: "translate(-526.521 -897.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M638.491,954.711v12.948H618.143V939.912h5.549a14.8,14.8,0,0,1,14.8,14.8Z",
    transform: "translate(-531.204 -897.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M632.941,954.711v12.948h-14.8V939.912a14.795,14.795,0,0,1,14.8,14.8Z",
    transform: "translate(-531.204 -897.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M633.808,974.044v22.2a14.795,14.795,0,0,1-14.8,14.8h-11.1a14.794,14.794,0,0,1-14.8-14.8v-22.2Z",
    transform: "translate(-526.521 -903.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M628.258,974.044v22.2a14.793,14.793,0,0,1-14.8,14.8h-5.55a14.794,14.794,0,0,1-14.8-14.8v-22.2Z",
    transform: "translate(-526.521 -903.753)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.746,894.4v72.141a3.711,3.711,0,0,0,3.7,3.7H514.9a3.711,3.711,0,0,1-3.7-3.7V898.1a3.731,3.731,0,0,1,3.552-3.7Z",
    transform: "translate(-0.426 -1.703)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.921 885.302)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M512.621,898.955V967.4h-3.7V898.955Z",
    transform: "translate(-508.921 -887.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M510.774,918.582a1.951,1.951,0,0,0,1.313-.536,1.876,1.876,0,0,0,0-2.627l-.277-.223a1.4,1.4,0,0,0-.333-.167,1.144,1.144,0,0,0-.333-.111,2.674,2.674,0,0,0-.369-.037,1.944,1.944,0,0,0-1.314.536,1.824,1.824,0,0,0,.61,3.015A1.852,1.852,0,0,0,510.774,918.582Z",
    transform: "translate(-508.924 -890.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M608.809,928.818V896.4a5.555,5.555,0,0,0-5.549-5.55H601.41a5.555,5.555,0,0,0-5.55-5.549H564.415a7.353,7.353,0,0,0-5.55,2.557,7.349,7.349,0,0,0-5.549-2.557H521.869a5.555,5.555,0,0,0-5.549,5.549h-1.849a5.556,5.556,0,0,0-5.55,5.55v7.4a1.85,1.85,0,1,0,3.7,0v-7.4a1.853,1.853,0,0,1,1.85-1.85h1.849v66.592a1.849,1.849,0,0,0,1.849,1.849h57.343v3.7H514.471a1.852,1.852,0,0,1-1.85-1.849V918.6a1.85,1.85,0,1,0-3.7,0v46.244a5.555,5.555,0,0,0,5.55,5.549h61.042v9.249a16.668,16.668,0,0,0,16.648,16.648h11.1a16.667,16.667,0,0,0,16.648-16.648V944.494A16.662,16.662,0,0,0,608.809,928.818Zm-5.549-34.267a1.852,1.852,0,0,1,1.849,1.85v31.555a16.778,16.778,0,0,0-1.849-.109H601.41v-33.3Zm-24.047,61.043v-11.1a12.963,12.963,0,0,1,12.948-12.948h3.7v24.047ZM564.415,889H595.86a1.852,1.852,0,0,1,1.85,1.849v37h-5.55a16.668,16.668,0,0,0-16.648,16.648v7.4H564.6a7.31,7.31,0,0,0-3.884,1.146V892.7A3.7,3.7,0,0,1,564.415,889Zm-25.9,0v24.323l-4.1-5.13a1.848,1.848,0,0,0-2.888,0l-4.105,5.13V889Zm-18.5,1.849A1.852,1.852,0,0,1,521.869,889h1.85v29.6a1.85,1.85,0,0,0,3.294,1.155l5.955-7.443,5.955,7.443a1.849,1.849,0,0,0,3.294-1.155V889h11.1a3.7,3.7,0,0,1,3.7,3.7v60.336a7.294,7.294,0,0,0-3.876-1.143H520.02Zm0,64.742h33.12a3.979,3.979,0,0,1,3.831,3.7H520.02Zm40.738,3.7a3.987,3.987,0,0,1,3.841-3.7h10.914v3.7Zm42.5,33.3h-11.1a12.963,12.963,0,0,1-12.948-12.948V959.292h37V979.64A12.962,12.962,0,0,1,603.26,992.588Zm12.948-36.995H599.56V931.546h3.7a12.963,12.963,0,0,1,12.948,12.948Z",
    transform: "translate(-508.921 -885.302)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M624.133,938.567a23.123,23.123,0,0,0-6.43-.863H605.645a16.667,16.667,0,0,0-14.808,16.539v35.145a16.667,16.667,0,0,0,16.648,16.648h11.1a16.667,16.667,0,0,0,16.648-16.648V954.243A16.662,16.662,0,0,0,624.133,938.567Zm-9.249,2.728h3.7a12.963,12.963,0,0,1,12.948,12.948v11.1H614.884Zm-20.348,12.948a12.963,12.963,0,0,1,12.948-12.948h3.7v24.047H594.537Zm37,35.145a12.963,12.963,0,0,1-12.948,12.948h-11.1a12.963,12.963,0,0,1-12.948-12.948V969.041h37Z",
    transform: "translate(-15.324 -9.803)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramasDeFormacion);
export default __webpack_public_path__ + "static/media/programas_de_formacion.344d53fd890e816af1134c27d21eb50a.svg";
export { ForwardRef as ReactComponent };